import styled from "@emotion/styled";

export const TableContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  align-self: stretch;

  max-width: 100%;
  overflow-x: auto;
`;

export const IndexContainer = styled.div`
  display: flex;
  padding: 12px 24px;
  align-items: center;

  border-radius: 12px;
  background: var(--component-color-fill-alternative);

  .row {
    display: flex;
    align-items: center;
    gap: 20px;
  }

  .item {
    display: flex;
    width: 160px;
    align-items: center;
  }
`;

export const RowContainer = styled.div`
  display: flex;
  padding: 12px 24px;
  align-items: center;

  border-bottom: 1px solid var(--alias-color-line-normal);

  .row {
    display: flex;
    align-items: center;
    gap: 20px;
  }

  .item {
    display: flex;
    width: 160px;
    align-items: center;
    gap: 8px;
  }
`;
